import React from 'react';

import './styles.scss';

const SelectItem = ({option, handleOptionClick,}) => {
	return (
		<li
		  className="select__option"
		  data-name={option.title}
		  onClick={handleOptionClick}
		>
		  {option.title}
		</li>
	  );
};

export default SelectItem;
